import React from "react";

const amounts = [
  ["Balance Now", "balanceNow"],
  ["Reversed", "reversed"],
  ["Closing", "closing"],
  ["Deposits", "deposits"],
  ["Withdraws", "withdraws"],
  ["Transfers In", "transfersIn"],
  ["Transfers Out", "transfersOut"],
  ["Cashbacks", "cashbacks"],
  ["IB Earnings", "ibEarnings"],
  ["Adjustments", "adjustments"]
];

export const WalletReportSummary = ({ grandTotal }) => (
  <>
    Rows: {grandTotal.totalRows || 0}
    {Object.entries(grandTotal.byCurrency || {}).map(([currency, bucket]) => (
      <span key={currency}>
        {" | " + currency + ": " + amounts.map(([label, key]) => `${label}: ${Number(bucket[key] || 0).toFixed(2)}`).join(" | ")}
      </span>
    ))}
  </>
);
